import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaHeadset, FaChartLine, FaCogs, FaShieldAlt, FaRocket, FaUsers, FaTools, FaHandshake } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
    {
        icon: <FaHeadset size={80} color="var(--brand-primary)" />,
        title: "24/7 System Monitoring",
        description: "Round-the-clock monitoring of your systems to detect and resolve issues before they impact users. We provide proactive alerts and rapid response to ensure maximum uptime.",
    },
    {
        icon: <FaTools size={80} color="var(--brand-primary)" />,
        title: "Maintenance & Bug Fixes",
        description: "Regular maintenance, bug fixes, and patches to keep your software running smoothly. We address issues quickly and ensure your system stays secure and up-to-date.",
    },
    {
        icon: <FaRocket size={80} color="var(--brand-primary)" />,
        title: "Feature Enhancements",
        description: "Continuous improvement with new features and enhancements based on user feedback and business needs. We help your product evolve to stay competitive and valuable.",
    },
    {
        icon: <FaChartLine size={80} color="var(--brand-primary)" />,
        title: "Performance Optimization",
        description: "Ongoing performance tuning and optimization as your user base grows. We ensure your application continues to deliver fast, reliable experiences at scale.",
    },
    {
        icon: <FaShieldAlt size={80} color="var(--brand-primary)" />,
        title: "Security Updates & Patches",
        description: "Regular security updates to protect against emerging threats. We monitor vulnerabilities and apply patches promptly to keep your systems secure.",
    },
    {
        icon: <FaCogs size={80} color="var(--brand-primary)" />,
        title: "Infrastructure Management",
        description: "Manage and optimize your cloud infrastructure for cost and performance. We handle scaling, backups, disaster recovery, and infrastructure updates.",
    },
    {
        icon: <FaUsers size={80} color="var(--brand-primary)" />,
        title: "Dedicated Support Team",
        description: "Access to experienced engineers who understand your system inside and out. We provide responsive support and act as an extension of your team.",
    },
    {
        icon: <FaHandshake size={80} color="var(--brand-primary)" />,
        title: "Strategic Partnership",
        description: "Long-term partnership focused on your success. We provide strategic guidance, technical expertise, and proactive recommendations as your business evolves.",
    },
];

const OngoingSupportEngineeringPartnership = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>Ongoing Support & Engineering Partnership - Syrol Tech</title>
                <meta name="description" content="Long-term technical partnership including system monitoring, enhancements, optimization, and support as your product evolves." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="Ongoing Support & Engineering Partnership"
                pageName="Ongoing Support & Engineering Partnership"
                breadcrumbsImg={bannerbg}
            />
            <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
                <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
                    <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Partner with us for long-term success</h1>
                    <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>Long-term technical partnership including system monitoring, enhancements, optimization, and support as your product evolves.</p>
                    <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
                </div>
            </section>
            <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
                <div className="container pb-66 md-pb-46">
                    <h2 className="service-title mb-32">Our Ongoing Support & Engineering Partnership Services</h2>
                    {serviceCards.map((card, idx) => (
                        <ServiceCard
                            key={idx}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
};

export default OngoingSupportEngineeringPartnership;
